import { library } from '@fortawesome/fontawesome-svg-core';
import { faSquare, faSigma, faXmark, faMap, faText } from '@fortawesome/pro-regular-svg-icons';

library.add(faSquare, faSigma, faXmark, faMap, faText);